import { useEffect, useRef, useState } from 'react';

export const useGatsbyBuildCheck = () => {
    // Check if Gatsby is in build mode.
    const isBuildMode = useRef(typeof window === 'undefined');
    // State to store the initial page render check.
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
        // Set the initial page render flag.
        setIsInitialRender(false);
    }, []);

    return { build: isBuildMode.current, initial: isInitialRender };
};
